export function StockOutBadge() {
  return (
    <div className="absolute rounded-[8px] bg-primary text-center opacity-100">
      <p className="z-50 px-[1rem] py-[0.625rem] text-[0.85rem] text-[#FFFFFF] md:px-[1.25rem] md:text-[1rem]">
        Stock Out
      </p>
    </div>
  );
}
